module.exports = __webpack_public_path__ + "img/maintenance-2.be3a9ece.png";